* {
  box-sizing: border-box;
  scroll-behavior: smooth;
  --white: white;
  --black: black;
  --softBlack: #111;
  --background-color: #f0fafa;
  --title-color: #ffdae2;
  --title-shadow-color: #dfbfc4;
  --aside-color: #f3b0c3;
  --footer-color: #555;
}

body::-webkit-scrollbar {
  width: 10px;
  display: block;
}
body::-webkit-scrollbar-thumb {
  background: #252525;
  border-radius: 10px;
}
body::-webkit-scrollbar-button,
body::-webkit-scrollbar-track {
  background: var(--black, black);
}
body {
  margin: 0;
}
input[type='number'],
input[type='text'] {
  padding: 0.5rem 1rem;
  border-radius: 10px;
}
label {
  line-height: 2rem;
}

[type='radio'],
span {
  vertical-align: middle;
}
thead {
  background-color: transparent;
  line-height: 2;
}
tr:hover {
  background-color: #252525;
}
td {
  padding: 0.5rem 1rem;
  word-break: keep-all;
}
code {
  background-color: #333;
  padding: 0 0.5rem;
  margin: 0.1rem 0;
  display: inline-block;
  border-radius: 7px;
  line-height: 2;
}
td > code {
  white-space: nowrap;
}

[type='radio'] {
  appearance: none;
  border: max(2px, 0.1em) solid gray;
  border-radius: 50%;
  width: 1.25em;
  height: 1.25em;
  transition: border 0.15s ease-out;
  margin-right: 0.5rem;
}

[type='radio']:checked {
  border: 0.4em solid #83b2f8;
}

[type='radio']:focus-visible {
  outline-offset: max(2px, 0.1em);
  outline: max(2px, 0.1em) dotted tomato;
}

[type='radio']:hover {
  box-shadow: 0 0 0 max(4px, 0.2em) lightgray;
  cursor: pointer;
}

[type='radio']:hover + span {
  cursor: pointer;
}

[type='radio']:disabled {
  background-color: lightgray;
  box-shadow: none;
  opacity: 0.7;
  cursor: not-allowed;
}

[type='radio']:disabled + span {
  opacity: 0.7;
  cursor: not-allowed;
}

.input_text {
  width: 300px;
  height: 50px;
  border-radius: 10px;
  padding: 10px 20px;
}
.header {
  position: relative;
  height: 100vh;
  color: var(--title-color, black);
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  font-family: 'Dancing Script', cursive;
}
.header > h1 {
  margin: 0;
  padding-bottom: 3.5rem;
  position: absolute;
  font-size: 100px;
}
.layout {
  background: linear-gradient(180deg, black 1%, #111 99%);
  color: var(--white, white);
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding-top: 4rem;
  padding-bottom: 10rem;
  position: relative;
}
.layout > div {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.aside {
  position: sticky;
  top: 3rem;
  width: 16rem;
}
.aside > ul {
  list-style-type: none;
}
.aside.left > ul > li {
  height: 3rem;
}
.aside.right > ul > li {
  display: flex;
  flex-direction: column;
}
.aside.right > ul > li > h2 {
  margin: 0;
}
.aside > ul > li > a {
  color: var(--white, white);
  text-decoration: none;
}
.aside.left {
  border-right: 2px solid var(--aside-color);
}
.aside.right {
  border-left: 2px solid var(--aside-color);
  width: 16rem;
  padding-right: 2rem;
}
.aside details {
  font-size: 1.5rem;
}
.aside details > label {
  width: 100%;
  display: block;
  font-size: 1.2rem;
}
.aside details > summary {
  cursor: pointer;
  font-size: 1.3rem;
  margin: 0.4rem 0;
}
.components {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0 7rem;
  gap: 3rem;
}
.components > div {
  width: 100%;
}
.validation_message {
  color: red;
  word-break: break-all;
}
.flex {
  display: flex;
  align-items: center;
  justify-content: center;
}

.label_class {
  border-radius: 15px;
  border: 2px solid #6bc94d;
  background-color: white;
  color: black;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px 20px;
}
.label_check_class {
  background-color: #6bc94d;
}

.radio_list_class {
  display: flex;
  align-items: center;
  justify-content: center;
}

.option_table {
  border-radius: 10px;
  border: 1px solid #888;
  border-collapse: collapse;
  margin: 2rem 0;
  width: 100%;
}

.footer {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem 0 5rem;
  border-top: 1px solid var(--footer-color);
  background-color: var(--black, black);
}
.github {
  text-transform: uppercase;
  text-decoration: none;
  color: var(--footer-color);
}

/* components */
.component_container {
  margin: 0 0 2rem;
}
.component_title {
  line-height: 1 !important;
  font-size: 6rem !important;
}
